export default {
  methods: {
    cleanVehicleMultiSelectLocationData (data) {
      const conditionalClears = {
        'flat_tires_location': {
          conditionalField: 'all_tires_inflated',
          clearValue: 1
        },
        'wheels_removed_location': {
          conditionalField: 'wheels_removed',
          clearValue: 0
        },
        'body_panels_damage_location': {
          conditionalField: 'body_panels_intact',
          clearValue: 1
        },
        'body_damage_location': {
          conditionalField: 'body_damage_free',
          clearValue: 1
        },
        'mirrors_lights_glass_damage_location': {
          conditionalField: 'mirrors_lights_glass_intact',
          clearValue: 1
        }
      }
      let result = {...data}
      for (const key in result) {
        if (Array.isArray(result[key])) {
          // extract only the 'value' from each object, or clear the array for submission based on user's answers.
          if (conditionalClears[key] && result[conditionalClears[key].conditionalField] === conditionalClears[key].clearValue) {
            result[key] = []
          } else {
            result[key] = result[key].map(item => item.value)
          }
        }
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Vehicle/VehicleFormMixin.js